import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineCard } from '../../base/outline-card/outline-card';
import '../ghs-icon/ghs-icon';

import componentStyles from './ghs-infographics-card.css.lit';
import { LightController } from '../../controllers/light-controller';

/**
 * The infographics Card component.
 * @element ghs-infographics-card
 * @slot default - The default slot.
 */
@customElement('ghs-infographics-card')
export class GhsInfographicsCard extends OutlineCard {
  static styles = [componentStyles];

  lightController = new LightController(
    this,
    GhsInfographicsCard.styles,
    this.tagName.toLowerCase()
  );

  /**
   * Background color of the card. Defaults to 'white'
   */
  @property({ type: String, attribute: 'bg-color', reflect: true })
  bgColor: 'dark' | 'light' | 'white' | '' = 'white';

  render(): TemplateResult {
    const wrapperClasses = {
      'bg-color': this.bgColor,
    };

    return html`
      <div class="infographics-card ${classMap(wrapperClasses)}">
        <div class="heading">
          <slot name="infographics-heading"></slot>
        </div>
        <slot></slot>
      </div>
    `;
  }
}
